import React from 'react';
import { Typography } from '@mui/material';

export default function MintBatchErrorTab({ item }) {
    return (
        <>
            <h4
                style={{
                    textAlign: 'center',
                    marginBotto: '0.5rem',
                    width: '100%',
                    fontWeight: '700',
                    color: 'red',
                    fontSize: '16px',
                    lineHeight: '20px',
                    fontFamily: 'Montserrat',
                }}
            >
                Error in csv file
            </h4>
            {item.map((row) => {
                return row.map((item, index) => {
                    return (
                        <Typography
                            key={index}
                            componemt="p"
                            sx={{
                                margin: '0px',
                                padding: '0 0.5rem',
                                width: '100%',
                                fontWeight: '400',
                                fontSize: '12px',
                                lineHeight: '16px',
                                fontFamily: 'Montserrat',
                            }}
                        >
                            `Row: {item.row + 1}: {item.message}`
                        </Typography>
                    );
                });
            })}
        </>
    );
}
